import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";

const ProgressIndicator = (props) => {

    return (
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={props.open}
        >
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <CircularProgress />
                <Typography variant="h6" component="div" sx={{ mt: 2 }}>
                   { props.text || "Please wait."}
                </Typography>
            </Box>

        </Backdrop>
    );
};

export default ProgressIndicator;

ProgressIndicator.prototype = {
    text: PropTypes.string,
    open: PropTypes.bool,
}